let styleTag = null;

const setStyleTag = ({ primary, secondary }, transparentPrimaryColor) => {
  if (!styleTag) {
    styleTag = document.createElement('style');
    document.querySelector('head').appendChild(styleTag);
  }
  styleTag.innerHTML = `.oct-common-header-primary-color {
  color: ${primary};
}
.oct-common-header-primary-background-color {
  background-color: ${primary}!important;
}
.oct-primary-background-color-trasparent {
  background-color: ${transparentPrimaryColor};
}
.oct-common-header-secondary-color {
  color: ${secondary};
}
.oct-common-header-secondary-background-color {
  background-color: ${secondary};
}`;
};

export default setStyleTag;
